function t(e) {
  return /\[[^\]]+\]/.test(e) ? !0 : /:/.test(e) ? !!/(?:Z|[+-]\d{2}(?::?\d{2})?)$/i.test(e) : !1;
}
export {
  t as hasZoneOrOffset
};
